
<template>
  <form id="formStepLegal" data-vv-scope="step-terminal">
    <div class="vx-row">
      <div class="vx-col md:w-1/2">
        <vs-input
          label="نام کاربری"
          name="terminalUserName"
          v-model="
            draftRequest.pspRequestShopAcceptors[0].acceptors[0].terminals[0]
              .terminalUserName
          "
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col md:w-1/2">
        <vs-input
          label="رمز عبور"
          name="terminalPassword"
          v-model="
            draftRequest.pspRequestShopAcceptors[0].acceptors[0].terminals[0]
              .terminalPassword
          "
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col md:w-1/2">
        <vs-input
          label="کد پذیرندگی"
          name="acceptorCode"
          v-model="
            draftRequest.pspRequestShopAcceptors[0].acceptors[0].acceptorCode
          "
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col md:w-1/2">
        <vs-input
          label="شماره ترمینال"
          name="terminalNumber"
          v-model="
            draftRequest.pspRequestShopAcceptors[0].acceptors[0].terminals[0]
              .terminalNumber
          "
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col md:w-1/2">
        <vs-input
          label="کد پیگیری"
          name="trackingNumberPsp"
          v-model="draftRequest.trackingNumberPsp"
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col w-full">
        <vs-button
          @click="saveTerminalData"
          class="my-3"
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-save"
          >ذخیره اطلاعات ترمینال</vs-button
        >
      </div>
    </div>
  </form>
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
</style>
<script>
const dict = {
  custom: {
    // nationalLegalCode: {
    //   numeric: "فقط عدد وارد کنید",
    // },
  },
};
import Vue from "vue";
Validator.localize("en", dict);

import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { CreateEditMode } from "@/enums.js";
export default {
  name: "edit-terminal-data",
  props: {
    draftRequest: {
      default: () => {
        return {
          draftMerchant: {},
          pspRequestShopAcceptors: [{ shop: {} }],
        };
      },
    },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      BirthCrtfctSeriesLetter,
      birthCrtfctSeriesLetter: {},
      birthdate: "",
    };
  },
  methods: {
    saveTerminalData() {
      if (!this.validateTerminalData) return;
      let loading = this.$vs.loading();
      const t = this.draftRequest.pspRequestShopAcceptors[0].acceptors[0]
        .terminals[0];
      let payload = {
        id: this.draftRequest.id,
        acceptorCode: this.draftRequest.pspRequestShopAcceptors[0].acceptors[0]
          .acceptorCode,
        trackingNumberPsp: this.draftRequest.trackingNumberPsp,
        terminalPassword: t.terminalPassword,
        terminalUserName: t.terminalUserName,
        terminalNumber: t.terminalNumber,
      };

      this.$http
        .post("/api/services/app/Draft/EditTerminalData", payload)
        .then((response) => {
          if (response.data.result == true) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "اطلاعات ترمینال با موفقیت ذخیره شد",
            });
            this.$vs.loading.close();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    validateTerminalData() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-terminal").then((result) => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
  },
  mounted() {
  },
};
</script>